import { Flex, Text, useSarah } from "@unifize/sarah";
import i18n from "i18next";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeGroupModal, setGroupModalAttributes } from "src/actions/group";
import GridRowCount from "src/components/AgGrid/GridRowCount";
import Icon from "src/components/Icon";
import Search from "src/components/SearchHeader.old/Search";
import {
  Button,
  ButtonActive,
  Buttons,
  Header as StyledHeader,
} from "src/components/SearchHeader.old/styles";
import k from "src/i18n/keys";
import {
  getCurrentUserId,
  getGroupsModalShow,
  getRole,
  getSelectedRows,
} from "src/reducers";
import { iconSize } from "src/styles/constants/size";
import { AppState } from "src/types";
import NewGroup from "../Groups/New";
import New from "./New";
import { SearchContainer } from "./styles";

interface Props {
  text?: string;
  handleSearch: (value: string) => void;
}

const Header = ({ text = "", handleSearch }: Props): React.ReactElement => {
  const dispatch = useDispatch();
  const selectedRows = useSelector(({ app }: { app: AppState }) =>
    getSelectedRows(app),
  );
  const showGroupModal = useSelector(({ app }: { app: AppState }) =>
    getGroupsModalShow(app),
  );
  const currentUserId = useSelector(({ app }: { app: AppState }) =>
    getCurrentUserId(app),
  );
  const role = useSelector(({ app }: { app: AppState }) =>
    getRole(app, currentUserId),
  );
  const [showAddContact, setShowAddContact] = useState(false);
  const { colors } = useSarah();

  const createGroup = () => {
    dispatch(
      setGroupModalAttributes({
        members: selectedRows,
        show: true,
      }),
    );
  };

  const handleCloseGroupModal = () => {
    dispatch(closeGroupModal());
  };

  const toggleAddContact = () => {
    if (role !== "demo") {
      setShowAddContact((prev) => !prev);
    }
  };

  const secondary = selectedRows.length > 0;

  return (
    <>
      <StyledHeader>
        <SearchContainer>
          <Search search={text} handleSearch={handleSearch} />
          <Flex
            style={{
              paddingLeft: 4,
              whiteSpace: "nowrap",
              alignItems: "center",
            }}
          >
            <Text variant="caption" color={colors.text.secondary}>
              <GridRowCount gridId="people-contacts">
                {(count) => `${count} ${i18n.t(k.RESULTS)}`}
              </GridRowCount>
            </Text>
          </Flex>
        </SearchContainer>
        <Buttons>
          <div>
            {secondary ? (
              <ButtonActive onClick={createGroup}>
                <Icon icon="plusCircle" size={iconSize.space_l} />
                {i18n.t(k.ADD_TO_GROUP)}
              </ButtonActive>
            ) : null}

            <Button
              type="button"
              onClick={toggleAddContact}
              data-cy="createProcessTemplate"
            >
              <Icon icon="plusCircle" size={iconSize.space_l} />
              {i18n.t(k.ADD_CONTACTS)}
            </Button>
          </div>
        </Buttons>
      </StyledHeader>
      {showGroupModal ? <NewGroup handleClose={handleCloseGroupModal} /> : null}
      <New show={showAddContact} handleClose={toggleAddContact} />
    </>
  );
};

export default Header;
